import {useLayoutEffect,useRef} from 'react';
import {overviewContentBottom,overviewViewportBottom} from './overviewViewportBounds';

// Fit the planner to the visible workspace, including the native desktop shell.
export default function useOverviewPlannerHeight(active) {
  const ref=useRef(null);
  useLayoutEffect(()=>{
    if(!active||!ref.current)return undefined;
    const element=ref.current;
    const measure=()=>{
      const page=element.closest('.desktop-page--overview');
      const bottom=Math.min(overviewViewportBottom(element),page?overviewContentBottom(page):window.innerHeight);
      // Phone pages scroll naturally; fitting the remaining viewport there
      // would squeeze the calendar below the rail into a tiny strip.
      const height=window.innerWidth<=950
        ?Math.max(420,Math.round((window.visualViewport?.height||window.innerHeight)*.7))
        :Math.max(160,Math.floor(bottom-element.getBoundingClientRect().top-8));
      const next=`${Math.round(height)}px`;
      if(element.style.getPropertyValue('--overview-planner-height')!==next)element.style.setProperty('--overview-planner-height',next);
    };
    measure();
    // Modal scroll locking can resize the page. Write the new height on the
    // next frame rather than during ResizeObserver's layout-delivery cycle.
    let frame=0;
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;measure();});};
    const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(schedule);
    const layout=element.closest('.overview-workspace')||element.parentElement;if(layout)observer?.observe(layout);
    window.addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);
    return()=>{observer?.disconnect();if(frame)cancelAnimationFrame(frame);window.removeEventListener('resize',schedule);window.visualViewport?.removeEventListener('resize',schedule);};
  },[active]);
  return ref;
}

